import { UserStorageManager } from "@core/managers/user-storage.manager";
import { X_AUTH_TOKEN } from "@core/constants";
import { TokenManager } from "../managers/token.manager";
/**
 * Intercept all requests to add the authorization token if it exists
 * @param {*} config - axios request config
 * @param {Boolean} [config.disableToken] - if set to true, do not add token to headers
 * @returns initial call config
 */
export async function authTokenInterceptor(config) {
  if (config && config.disableToken !== true) {
    const accessToken = await UserStorageManager.getToken();
    if (accessToken) {
      config.headers[X_AUTH_TOKEN] = accessToken;
    }
  }

  return config;
}

/**
 * Intercept all requests to add the JWT token if it exists
 * @param {*} config - axios request config
 * @param {Boolean} [config.disableToken] - if set to true, do not add token to headers
 * @returns initial call config
 */
export async function jwtInterceptor(config) {
  if (config && config.disableToken !== true) {
    const accessToken = await UserStorageManager.getToken();
    const refreshToken = await UserStorageManager.getRefreshToken();
    if (accessToken) {
      const tokenIsExpireSoon = TokenManager.isTokenExpiringSoon(accessToken);
      config.headers.Authorization = `Bearer ${accessToken}`;
      if (tokenIsExpireSoon && refreshToken) {
        await TokenManager.getCandidateToken({ refreshToken });
      }
    }
  }
  return config;
}
